import { onServerPrefetch, toValue } from 'vue'
import type { MaybeRefOrGetter } from 'vue'

export function useServerQuery<T extends { suspense: () => Promise<unknown> }>(
  query: T,
  enabled: MaybeRefOrGetter<boolean | undefined> = true,
) {
  if (toValue(enabled) !== false) {
    onServerPrefetch(query.suspense)
  }

  return query
}
